import React from 'react';
import Leaf from 'lucide-react/dist/esm/icons/leaf';
import Check from 'lucide-react/dist/esm/icons/check';

const LandingPricing = ({ t, navigate, handleStartFreeTrial }) => {
  return (
    <>
      {/* ===== SECCION 5: PLANES Y PRECIOS ===== */}
      <section className="px-4 py-16" style={{ backgroundColor: '#F2F2F2' }} id="pricing">
        <div className="max-w-5xl mx-auto">
          {/* Brand Header */}
          <div className="text-center mb-8">
            <h2 
              className="text-4xl md:text-5xl mb-2"
              style={{ fontFamily: "'Patrick Hand', cursive", color: '#27AE60' }}
            >
              {t('landing.pricing.brand')}
            </h2>
            <p 
              className="text-lg md:text-xl"
              style={{ fontFamily: "'Nunito', sans-serif", color: '#666', fontStyle: 'italic' }}
            >
              {t('landing.pricing.tagline')}
            </p>
          </div>
          
          <h3 
            className="text-2xl md:text-3xl text-center mb-4"
            style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
            data-testid="pricing-title"
          >
            {t('landing.pricing.title')} <span style={{ color: '#27AE60' }}>{t('landing.pricing.titleHighlight')}</span>
          </h3>
          <p 
            className="text-center text-base mb-8"
            style={{ fontFamily: "'Nunito', sans-serif", color: '#666' }}
          >
            {t('landing.pricing.subtitle')}
          </p>

          {/* Plans Grid - Single column (Pro disabled) */}
          <div className="flex justify-center max-w-xl mx-auto">
            {/* Plan Frugal - Now using v2 */}
            <div 
              className="rounded-2xl p-6 transition-all hover:scale-105 cursor-pointer w-full"
              style={{ 
                backgroundColor: '#F9F9F6',
                border: '3px solid #27AE60',
                boxShadow: '5px 5px 0 rgba(39,174,96,0.3)'
              }}
              onClick={() => navigate('/login?plan=frugal')}
              data-testid="plan-frugal-card"
            >
              
              <div 
                className="w-14 h-14 rounded-xl flex items-center justify-center mb-4"
                style={{ backgroundColor: '#E8F5E9' }}
              >
                <Leaf className="w-7 h-7" style={{ color: '#27AE60' }} />
              </div>
              <h3 
                className="text-2xl mb-1"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
              >
                {t('landing.pricing.frugal.name')}
              </h3>
              <p className="text-sm mb-3 font-bold" style={{ color: '#27AE60', fontFamily: "'Nunito', sans-serif" }}>
                {t('landing.pricing.frugal.tagline')}
              </p>
              {/* Price with offer style */}
              <div className="mb-2">
                <p 
                  className="text-3xl font-bold inline-block"
                  style={{ fontFamily: "'Patrick Hand', cursive", color: '#27AE60' }}
                >
                  {t('landing.pricing.frugal.price')}
                </p>
                <span className="text-sm font-normal" style={{ color: '#666' }}>{t('landing.pricing.frugal.period')}</span>
              </div>
              <p className="text-xs mb-4" style={{ color: '#666', fontFamily: "'Nunito', sans-serif" }}>
                {t('landing.pricing.frugal.priceNote')}
              </p>
              <ul className="space-y-2 mb-6">
                {(t('landing.pricing.frugal.features', { returnObjects: true }) || []).map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm" style={{ color: '#4A4A4A' }}>
                    <Check className="w-4 h-4" style={{ color: '#27AE60' }} />
                    {feature}
                  </li>
                ))}
              </ul>
              <button
                onClick={handleStartFreeTrial}
                className="w-full py-3 rounded-xl font-semibold transition-all hover:opacity-90"
                style={{ 
                  backgroundColor: '#27AE60', 
                  color: 'white',
                  fontFamily: "'Patrick Hand', cursive",
                  fontSize: '1.1rem',
                  boxShadow: '3px 3px 0 #2C2C2C'
                }}
              >
                {t('landing.pricing.frugal.cta')}
              </button>
              <p 
                className="text-center mt-2"
                style={{ fontFamily: "'Nunito', sans-serif", fontSize: '0.8rem', color: '#27AE60' }}
              >
                {t('landing.pricing.frugal.trialBadge')}
              </p>
              {/* Footer text below button */}
              <p 
                className="text-center mt-3"
                style={{ 
                  fontFamily: "'Nunito', sans-serif",
                  fontSize: '0.85rem',
                  color: '#666'
                }}
              >
                {t('landing.pricing.footer')}
              </p>
            </div>
          </div>

          <p 
            className="text-center mt-8 text-sm"
            style={{ fontFamily: "'Nunito', sans-serif", color: '#888' }}
          >
            {t('landing.pricing.footer')}
          </p>
        </div>
      </section>

      {/* ===== SECCION 6: CIERRE & AI (Call to Action) ===== */}
      <section className="px-4 py-16" style={{ backgroundColor: '#F9F9F6' }}>
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            {/* Texto y CTA - Ahora a la izquierda */}
            <div className="text-center md:text-left order-1 md:order-1">
              <h2 
                className="text-3xl md:text-4xl mb-4"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
                data-testid="cta-title"
              >
                {t('landing.coPilot.title')}
              </h2>
              
              <p 
                className="text-lg mb-8"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.coPilot.subtitle')} <strong style={{ color: '#27AE60' }}>{t('landing.coPilot.highlight')}</strong>
              </p>
              
              {/* Chat Example */}
              <div 
                className="p-4 rounded-2xl mb-8"
                style={{ 
                  backgroundColor: '#FFFFFF',
                  border: '2px solid #2C2C2C',
                  boxShadow: '4px 4px 0 rgba(44,44,44,0.1)'
                }}
              >
                <div className="space-y-3">
                  <div 
                    className="px-3 py-2 rounded-xl inline-block"
                    style={{ backgroundColor: '#E8F5E9', border: '1px solid #27AE60' }}
                  >
                    <span style={{ fontFamily: "'Patrick Hand', cursive" }}>
                      &ldquo;{t('landing.coPilot.question')}&rdquo;
                    </span>
                  </div>
                  <div className="flex justify-end">
                    <div 
                      className="px-3 py-2 rounded-xl inline-block"
                      style={{ backgroundColor: '#F9F9F6', border: '1px solid #2C2C2C' }}
                    >
                      <span style={{ fontFamily: "'Patrick Hand', cursive" }}>
                        &ldquo;{t('landing.coPilot.answer')}&rdquo;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Robot Boceto - Ahora a la derecha */}
            <div className="flex justify-center order-2 md:order-2 relative">
              <img 
                src="/little-zen-robot-optimized.webp" 
                alt={t('landing.coPilot.title')}
                className="w-64 md:w-80 h-auto"
                style={{ 
                  filter: 'drop-shadow(4px 4px 8px rgba(0,0,0,0.1))',
                  mixBlendMode: 'multiply'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ===== FOOTER SIMPLE ===== */}
      <footer className="px-4 py-8" style={{ backgroundColor: '#2C2C2C', color: '#F9F9F6' }}>
        <div className="max-w-6xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <img src="/zensaver-logo-new.png" alt="Zensaver" className="h-10 w-auto" style={{ filter: 'brightness(0) invert(1)' }} />
          </div>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '0.9rem', color: '#AAA' }}>
            {t('landing.footer.copyright', '\u00A9 2026 Zensaver. Your financial freedom, one expense at a time.')}
          </p>
          <p className="mt-2" style={{ fontFamily: "'Patrick Hand', cursive", fontSize: '1rem' }}>
            {t('landing.footer.madeWith', 'Made with \uD83D\uDC9A for your peace of mind')}
          </p>
        </div>
      </footer>
    </>
  );
};

export default LandingPricing;
